import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import PromoterModule from '@/modules/promoter';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/promoter')({
  component: PromoterPage,
});

function PromoterPage() {
  const { canAccessGlobalLeaderboard } = useAccessControl();

  if (!canAccessGlobalLeaderboard) {
    return <AccessDenied />;
  }

  return <PromoterModule />;
}
